import React from 'react'
import "./index.css"
import { Container } from 'react-bootstrap'
import SectionTitle from '@/components/common-components/SectionTitle'
import Post from '@/components/common-components/post/Post'
import { formatDate } from '@/utlility/Functions'

const RelatedContent = ({ recentBlogs }) => (
  <section className='related-content'>
    <Container>
      <div className="text-center text-sm-start">
        <SectionTitle sectionName="blog" title="Related post" />
      </div>
      <div className='related-post-cover grid'>
        {recentBlogs?.data?.map((item, i) => (
          <div className='g-col-12 g-col-sm-6 g-col-lg-4' key={i}>
            <Post
              image={item.blog_image}
              auther={item.author}
              date={formatDate(item.created_at, "MMMM DD, YYYY")}
              title={item.blog_title}
              link={item.blog_slug}
            />
          </div>
        ))}
      </div>
    </Container>
  </section>
)

export default RelatedContent